import { useEffect } from 'react';

/**
 * «Cliente eliminado», cerca del pulgar y sin mover nada.
 *
 * El aviso de que algo salió bien vivía al principio de la página. Después de
 * borrar el último cliente de una lista larga, la confirmación aparecía a
 * setenta filas de distancia: en la práctica nadie la veía, y quedaba la duda de
 * si la acción había pasado o no.
 *
 * Va fijo abajo, dura unos segundos y se va solo. No empuja el contenido —es
 * `fixed`, no participa del flujo— así que la lista queda donde estaba.
 *
 * No lleva botón de cerrar a propósito: un aviso que hay que despachar es una
 * tarea más, y esto no es una tarea. Si hace falta contestar algo, no es un
 * aviso: es una pregunta, y ésas van en la hoja de confirmación.
 */
export function AvisoFlotante({
  texto,
  onCerrar,
  segundos = 4,
}: {
  texto: string | null;
  onCerrar: () => void;
  segundos?: number;
}) {
  useEffect(() => {
    if (!texto) return;
    const t = setTimeout(onCerrar, segundos * 1000);
    return () => clearTimeout(t);
  }, [texto, onCerrar, segundos]);

  if (!texto) return null;

  return (
    <div
      // `pointer-events-none`: es un cartel, no un obstáculo. Sin esto se come
      // el toque del botón que quedó justo debajo.
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-4"
      style={{ paddingBottom: 'calc(var(--seguro-abajo) + 1rem)' }}
    >
      <p
        role="status"
        className="max-w-2xl rounded-full bg-[var(--accion)] px-4 py-2 text-sm text-[var(--sobre-accion)] shadow-lg"
        data-testid="aviso-flotante"
      >
        {texto}
      </p>
    </div>
  );
}
